import React from 'react';
import Anchor from "../objects/Anchor";

const IntroBanner = props => {

    const {
        introBannerImage,
        introBannerHeading,
        introBannerCopy,
        introBannerCtaLink,
        introBannerCtaCopy,
        typeOfLink
    } = props;

    const isTarget = typeOfLink === 'internal link' ? false : true
    const isInternal = typeOfLink === 'internal link' ? true : false

    return (
        <div className="container hero-banner-half" data-aos>
            <div className="image" style ={ { backgroundImage: `url(${introBannerImage})` } }></div>
            <div className="row">
                <div className="inner">
                    <div className="col-12 inner-content">
                        <h1 className="heading-main">{introBannerHeading}</h1>
                        <p className="body-copy">{introBannerCopy}</p>
                        <Anchor internal={isInternal} target={isTarget} path={introBannerCtaLink} anchorClass={'theme-button'}>
                            {introBannerCtaCopy}
                        </Anchor>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntroBanner;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/IntroBanner.js